module.exports = __webpack_public_path__ + "img/symbol_anker.b2feb61.webp";